module.exports = __webpack_public_path__ + "static/media/ecommerce_img.5055d659.png";